import React, { useState, useEffect, useRef, Component } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../component/loadingbar/Spinner";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const EmailTmpltEditor = () => {
  const token = config.token;
  const { eid, tmpltfor } = useParams();
  const navigate = useNavigate();

  // ---------------------------------- state handling ----------------------------------------
  const [loading, setLoading] = useState(false);
  const [tmpltData, setTmpltData] = useState("");
  const [tmpltHint, setTmpltHint] = useState("");

  useEffect(() => {
    setLoading(true);
    // --------------------------Fetch selected template list
    fetch(
      `${config.host_url}email-templates/${decodeURIComponent(atob(eid))}`,
      {
        method: "GET",
        headers: {
          token: token,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          data.data.template && setTmpltData(data.data.template);
          data.data.hint && setTmpltHint(data.data.hint);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching Student:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);
  return (
    <>
      <Breadcrumb
        txt="Manage Email Template"
        subpath={["Add Email Template", "Edit Template"]}
        url={["/addemailtemplate"]}
      />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">
              Edit Template ({decodeURIComponent(atob(tmpltfor))})
            </h5>
          </div>

          <div className="card-body">
            <form>
              {loading ? <Spinner /> : <></>}
              <div className={loading ? "d-none" : "d-block"}>
                {/* summary, (text editor) */}
                <div className="form-floating form-floating-outline mb-4">
                  <label htmlFor="assgSummary"> Template</label>
                  <CKEditor
                    name="tmpltData"
                    editor={ClassicEditor}
                    data={tmpltData}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setTmpltData(data);
                    }}
                  />
                  {tmpltHint && (
                    <div className="flex mt-2">
                      <span className="mdi mdi-alert-circle-outline text-gray-300 mr-1"></span>
                      <spam className="text-gray-300 "> {tmpltHint}</spam>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailTmpltEditor;
